"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const token_1 = require("../token");
const include_1 = require("./include");
const embed_1 = require("../node/embed");
const node_1 = require("../node");
class TwingTokenParserEmbed extends include_1.TwingTokenParserInclude {
    parse(token) {
        let stream = this.parser.getStream();
        let parent = this.parser.getExpressionParser().parseExpression();
        let embedArguments = this.parseArguments();
        let variables = embedArguments.variables;
        let only = embedArguments.only;
        let ignoreMissing = embedArguments.ignoreMissing;
        let parentToken;
        let fakeParentToken;
        parentToken = fakeParentToken = new token_1.TwingToken(token_1.TwingToken.STRING_TYPE, '__parent__', token.getLine(), token.getColumn());
        if (parent.getType() === node_1.TwingNodeType.EXPRESSION_CONSTANT) {
            parentToken = new token_1.TwingToken(token_1.TwingToken.STRING_TYPE, parent.getAttribute('value'), token.getLine(), token.getColumn());
        }
        else if (parent.getType() === node_1.TwingNodeType.EXPRESSION_NAME) {
            parentToken = new token_1.TwingToken(token_1.TwingToken.NAME_TYPE, parent.getAttribute('name'), token.getLine(), token.getColumn());
        }
        // inject a fake parent to make the parent() function work
        stream.injectTokens([
            new token_1.TwingToken(token_1.TwingToken.BLOCK_START_TYPE, '', token.getLine(), token.getColumn()),
            new token_1.TwingToken(token_1.TwingToken.NAME_TYPE, 'extends', token.getLine(), token.getColumn()),
            parentToken,
            new token_1.TwingToken(token_1.TwingToken.BLOCK_END_TYPE, '', token.getLine(), token.getColumn()),
        ]);
        let module = this.parser.parse(stream, [this, this.decideBlockEnd], true);
        // override the parent with the correct one
        if (fakeParentToken === parentToken) {
            module.setNode('parent', parent);
        }
        this.parser.embedTemplate(module);
        stream.expect(token_1.TwingToken.BLOCK_END_TYPE);
        return new embed_1.TwingNodeEmbed(module.getTemplateName(), module.getAttribute('index'), variables, only, ignoreMissing, token.getLine(), token.getColumn(), this.getTag());
    }
    decideBlockEnd(token) {
        return token.test(token_1.TwingToken.NAME_TYPE, 'endembed');
    }
    getTag() {
        return 'embed';
    }
}
exports.TwingTokenParserEmbed = TwingTokenParserEmbed;
